import { z } from "zod";

export enum RequestAIDetectionTypeEnum {
    ID_CARD = 1,
    TECHNICAL_LICENSE_CARD = 2,
}

export const RequestAIDetectionTypeEnumSchema = z.nativeEnum(RequestAIDetectionTypeEnum);